<template>
  <div class="element">
    <div
      v-for="(portfolio, index) in componentData.portfolioList"
      :key="portfolio.id"
      class="portfolio-container"
    >
      <mds-data-table
        size="small"
        row-numbers
        :header-configs="headers"
        :row-data="portfolio.securities"
      >
        <template v-slot:header>
          <thead class="table-header-names">
            <tr>
              <th class="table-numbered-column"></th>
              <th class="table-holdings-column">
                {{
                  `${labels.portfolio} ${componentData.portfolioList.length > 1 ? index + 1 : ''}`
                }}
              </th>
              <th class="table-allocations-column">
                {{ labels.allocation }}
              </th>
            </tr>
          </thead>
          <thead class="table-header-total">
            <tr>
              <th class="table-numbered-column"></th>
              <th class="table-holdings-column">{{ labels.total }}</th>
              <th class="table-allocations-column">
                {{ formatTotalValue(portfolio.totalInvestAmount, index) }}
              </th>
            </tr>
          </thead>
        </template>
      </mds-data-table>
    </div>
  </div>
</template>

<script>
import MwcVueHelperMixin, { MwcConfigMixin } from 'mwc-vue-component-helper';
import { MdsDataTable } from '@mds/data-table';
import defaultConfig from './_config';

export default {
  name: 'hypo-holdings',
  components: {
    MdsDataTable,
  },
  mixins: [MwcVueHelperMixin, MwcConfigMixin],
  props: {
    mwcId: {
      type: String,
      required: true,
    },
    config: {
      type: [String, Object],
      default: () => defaultConfig,
    },
    componentData: {
      type: [String, Object],
    },
  },
  provide() {
    // all MWC children should assume an mwcId is provided
    return ['mwcId'].reduce((provider, obj) => {
      Object.defineProperty(provider, obj, {
        enumerable: true,
        get: () => this[obj] || this[`$_${obj}`],
      });

      return provider;
    }, {});
  },
  data() {
    return {
      defaultConfig: {
        intlNamespace: this.mwcId,
        ...defaultConfig,
      },
    };
  },
  computed: {
    labels() {
      return {
        portfolio: this.translate('portfolio'),
        total: `${this.translate('total')}${this.valueLabel}`,
        allocation: `${this.translate('allocation')}${this.valueLabel}`,
      };
    },
    componentConfig() {
      return this.getComponentConfig().settings || defaultConfig;
    },
    valueLabel() {
      return this.componentConfig.usePercentages ? ' %' : this.componentConfig.labelSign;
    },
    headers() {
      return [
        {
          fieldName: 'securityName',
          sortable: false,
        },
        {
          fieldName: this.componentConfig.usePercentages ? 'weight' : 'amount',
          sortable: false,
          align: 'right',
          transform: value => {
            return value.toFixed(this.componentConfig.decimalDigits);
          },
        },
      ];
    },
  },
  methods: {
    totalAllocation(index) {
      const { securities } = this.componentData.portfolioList[index];
      return securities.reduce((total, item) => {
        return total + (this.componentConfig.usePercentages ? item.weight : item.amount);
      }, 0);
    },
    formatTotalValue(value, index) {
      return this.componentConfig.usePercentages
        ? this.totalAllocation(index).toFixed(this.componentConfig.decimalDigits)
        : value.toFixed(this.componentConfig.decimalDigits);
    },
  },
};
</script>

<style lang="scss">
@import '~@mds/constants';
@import './styles/variables';

.element {
  background-color: $mds-background-color-white;
  text-align: center;
  display: flex;
}

.table-numbered-column {
  width: 20px;
}
.table-holdings-column {
  padding: 4px 8px;
  text-align: left;
  width: 70%;
}
.table-allocations-column {
  text-align: right;
  white-space: nowrap;
  width: 30%;
}
.table-header-names {
  font-size: 14px;
  line-height: 18px;
  color: #5e5e5e;
}
.table-header-total {
  color: #1e1e1e;
  background-color: #f2f2f2;
  font-size: 16px;
  line-height: 22px;
}
.portfolio-container {
  margin-right: 48px;
  &:last-child {
    margin-right: 0px;
  }
}
</style>
